<template>
  <div>
    <div
      v-if="!scratchOffFinished"
      id="scratchOffContainer"
      key="scrollOff"
      class="text-white d-flex justify-content-center align-items-center my-3 mx-auto"
      style="position:relative; width:300px"
    />

    <div
      v-else
      key="scrollOffResult"
      class="text-white d-flex justify-content-center align-items-center my-3 mx-auto"
      style="position:relative; width:300px"
    >
      <img :src="awardImage">
    </div>
  </div>
</template>

<script>
import { ScratchOff } from '@/utils/scratchOff';

export default {
  props: {
    // 遮罩圖片
    maskImage: {
      type: String,
      required: true,
    },
    // 獎品圖片
    awardImage: {
      type: String,
      required: true,
    },
    // 是否可以刮
    isPlay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 顯示刮獎趴數
      showAwardPercent: 75,
      // 刮刮樂物件
      lottery: null,
      // 刮刮樂完成
      scratchOffFinished: false,
    };
  },
  mounted() {
    const vm = this;

    // 刮刮卡底下的內容選圖片的話，預設是會把刮刮卡的寬/高調成跟圖片一樣
    // 目前寬高固定都是300
    vm.lottery = new ScratchOff('scratchOffContainer', vm.maskImage, 'image', 300, 300, vm.drawCallback);
    vm.lottery.init(vm.awardImage, 'image');
  },
  methods: {
    clickmask() {

    },
    // 刮刮樂 callback
    drawCallback(percent) {
      if (!this.isPlay) { this.$emit('show'); }
      const vm = this;
      if (percent >= this.showAwardPercent) {
        vm.scratchOffFinished = true;
        // 移除監聽
        vm.lottery.removeListener();
        // 刪除物件
        vm.lottery = null;
        // 完成
        vm.$emit('done');
      }
    },
  },
};
</script>
